import React, { useCallback, useMemo } from "react";
import { ProjectPageNav } from "@/store/zustand/layoutStore";
import { navigationConfig } from "./navigationConfig";
import { SidebarButton } from "./SidebarButton";
import { useFeatureFlagEnabled } from "posthog-js/react";

interface ProjectSidebarProps {
  activeNav: ProjectPageNav | null;
  onNavChange: (nav: ProjectPageNav | null) => void;
}

export const ProjectSidebar: React.FC<ProjectSidebarProps> = React.memo(
  ({ activeNav, onNavChange }) => {
    const prdAgentEnabled = useFeatureFlagEnabled("prd-agent");

    const handleNavClick = useCallback(
      (navId: ProjectPageNav) => {
        onNavChange(activeNav === navId ? null : navId);
      },
      [activeNav, onNavChange],
    );

    // Filter navigation items based on feature flags
    const visibleNavItems = useMemo(() => {
      return navigationConfig.filter((navItem) => {
        // AI Chat requires prd-agent feature flag
        if (navItem.id === ProjectPageNav.AIChat) {
          return prdAgentEnabled;
        }
        return true;
      });
    }, [prdAgentEnabled]);

    return (
      <div className="flex flex-col items-center h-full pl-2 pr-2 pt-2 border-r border-secondary-n-900">
        <div className="flex flex-col items-center gap-1">
          {visibleNavItems.map((navItem) => (
            <SidebarButton
              key={navItem.id}
              icon={navItem.icon}
              isActive={activeNav === navItem.id}
              onClick={() => handleNavClick(navItem.id)}
              testId={`sidebar-nav-${navItem.id.toLowerCase().replace(/\s+/g, "-")}`}
            />
          ))}
        </div>
      </div>
    );
  },
);

ProjectSidebar.displayName = "ProjectSidebar";
